<div class="breadcrumbGlobal">
    <a [routerLink]="['/mydashboard']">
        <mat-icon>home</mat-icon>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <a [routerLink]="['/mago-university/mago-university']">
      <span translate>MENU.UNIVERSITY</span>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <a *ngIf="!course.TrainingPlan" [routerLink]="['/mago-university/mago-courses']">
        <span translate>COMMONS.COURSES</span>
    </a>
    <a *ngIf="course.TrainingPlan" [routerLink]="['/mago-university/mago-courses']" [queryParams]="{ trainingPlans: true }">
        <span translate>COMMONS.COURSESPLANS</span>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <span translate>{{ course.Description }}</span>
</div>
<tb-header [specificTitle]="course?.Description" parentPage="magoCourses"></tb-header>

<div class="contentGlobal text-center" *ngIf="course">

    <mat-card class="course-card course-card--courses">
        <mat-card-title>
          <div class="coursedetail-description-container">
            <button mat-icon-button id="favouriteButton" *ngIf="false" (click)="addRemoveFavourite()">
              <mat-icon>star</mat-icon>
            </button>
            <div class="coursedetail-description">
              {{course.Description}}
            </div>
          </div>
        </mat-card-title>

        <button *ngIf="!course.TrainingPlan" class="share-button" mat-mini-fab color="primary" (click)="shareCourse(course.Materials)">
          <mat-icon class="share-icon">
            share_ios
          </mat-icon>
        </button>


        <mat-card-content>

        <div class="coursedetail-content-container">
          <div>
            <img [src]="course.CourseImage" class="coursedetail-image">
          </div>
          <div class="coursedetail-content">
            <div><h4>{{course.Program}}</h4></div>
            <div><mat-label class="text-bold" translate>COMMONS.PRODUCT</mat-label>:<span [class]="['product-layout', 'bg-' + course.ProductCode.toLowerCase().replace('.', '') ]">{{this.universityService.getProductDescription(course.ProductCode)}}</span></div>
            <div>
              <mat-label *ngIf="!course.TrainingPlan" class="text-bold" translate>COMMONS.COURSEAREA</mat-label>
              <mat-label *ngIf="course.TrainingPlan" class="text-bold" translate>COMMONS.COURSEPLANAREA</mat-label>
              : {{getAreaString(course.LearningArea)}}
            </div>
            <div><mat-label class="text-bold" translate>COMMONS.COURSELANGUAGE</mat-label>: {{course.CourseLanguage}}</div>
            <div><mat-label class="text-bold" translate>COMMONS.COURSECOUNTRIES</mat-label>: <span translate>{{course.Countries ? course.Countries : 'COMMONS.ALL_COUNTRIES'}}</span></div>
            <div class="coursedetail-action-container">
              <button mat-flat-button class="left" color="primary" *ngIf="!course.TrainingPlan" (click)="openCourse(course.Materials)">
                <span translate>COMMONS.COURSEVIEW</span>
              </button>
            </div>
          </div>
        </div>

        <div class="coursedetail-aims-container">
          <h3>
            <mat-label translate>COMMONS.WHAT_WILL_LEARN</mat-label>
          </h3>
          {{course.Aims}}
        </div>
        <div class="coursedetail-program-container" *ngIf="!course.TrainingPlan">
          <h3><mat-label translate>COMMONS.COURSEPROGRAM</mat-label></h3>
          <span [innerHTML]="course.ExtendProgram"></span>
        </div>
        <div *ngIf="course.TrainingPlan">
          <ms-courses-plan-list [courseName]="course.CourseName"></ms-courses-plan-list>
        </div>
      </mat-card-content>
    </mat-card>
    <div style="margin-top: 2rem">
      <button mat-flat-button color="secondary" (click)="returnToList()">
        <mat-icon >chevron_left</mat-icon>
        <span  translate *ngIf="(!trainingPlan && !course.TrainingPlan) || course.TrainingPlan">
          COMMONS.BACK_TO_LIST
        </span>
        <span  translate *ngIf="trainingPlan && !course.TrainingPlan">
          COMMONS.BACK
        </span>
      </button></div>
</div>
